module.exports = __webpack_public_path__ + "static/media/EHS-Safeguarding-policy-and-procedure.c78f0a4e.pdf";